export default __webpack_public_path__ + "static/media/photo--lg--misc-13.251f7e44.jpg";